import { createSelector } from "reselect";

export const receiverSelector = createSelector(
    state => state.services.receiver,
    state => state
);